import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import useLang from "../../../../Shared/hooks/useLanguage";
import {
  AddIcon,
  CrossIcon,
  DoneIcon,
  RemoveICon,
} from "../../../../Shared/Icons";
// import { TestSetupSaveData } from "Services/NGSRunCreation";
import Expand from "./Expand";
import { validateFields } from "Pages/LIS/Toxicology/CommonFunctions";
import { SaveRunCreation } from "Services/NGSRunCreation";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";

function Row({
  row,
  rows,
  index,
  setRows,
  selectedBox,
  loadGridData,
  setSelectedBox,
  handleComplete,
  queryDisplayTagNames,
  handleDeleteOrReject,
  setIsAddButtonDisabled,
}: any) {
  const { t } = useLang();

  const [isExpand, setIsExpand] = useState<boolean>(false);
  const [disableSaveBbutton, setDisableSaveBbutton] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const showExpand = () => {
    setIsExpand(!isExpand);
  };

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const handleChange = (name: string, value: string, id: number) => {
    setRows((curr: any) =>
      curr.map((x: any) => (x.id === id ? { ...x, [name]: value } : x))
    );
  };

  const handleSave = async () => {
    const { isValid, invalidField } = validateFields({
      runName: row.runName,
    });

    if (!isValid) {
      const errorMessage = invalidField
        ? `Please Fill ${queryDisplayTagNames[invalidField] ?? ""} field`
        : "Invalid field found";

      toast.error(errorMessage);
      return;
    }

    const payload = {
      id: row.id,
      runName: row.runName,
      runDate: row.id === 0 ? new Date().toISOString() : row.runDate,
      runId: row.runId,
      projectId: row.projectId,
      notes: row.notes,
    };

    try {
      setDisableSaveBbutton(true);

      const res = await SaveRunCreation(payload);

      if (res?.data?.statusCode === 200) {
        loadGridData();
        setIsAddButtonDisabled(false);
        handleClose("dropdown2");
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error saving run creation:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setDisableSaveBbutton(false);
    }
  };

  const handleChangeSelectedIds = (checked: boolean, id: number): void => {
    setSelectedBox((prev: typeof selectedBox) => ({
      ...prev,
      ids: checked
        ? prev.ids.includes(id)
          ? prev.ids
          : [...prev.ids, id]
        : prev.ids.filter((item: number) => item !== id),
    }));
  };

  return (
    <>
      <TableRow className="h-30px">
        <TableCell>
          {row.rowStatus ? null : (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={showExpand}
              className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px"
            >
              {isExpand ? (
                <button
                  id={`NGSRunCreationDataPanelSetupExpandClose_${row.id}`}
                  className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px min-h-20px"
                >
                  <RemoveICon />
                </button>
              ) : (
                <button
                  id={`NGSRunCreationDataPanelSetupExpandOpen_${row.id}`}
                  className="btn btn-icon btn-icon-light btn-sm fw-bold btn-primary rounded h-20px w-20px min-h-20px"
                >
                  <AddIcon />
                </button>
              )}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          <label className="form-check form-check-sm form-check-solid d-flex justify-content-center">
            <input
              id={`ManageOrderNewOrderCheckBox_${row.id}`}
              className="form-check-input"
              type="checkbox"
              checked={selectedBox?.ids?.includes(row?.id)}
              onChange={(e) =>
                handleChangeSelectedIds(e.target.checked, row.id)
              }
            />
          </label>
        </TableCell>
        <TableCell>
          <div className="d-flex justify-content-center">
            {row?.rowStatus ? (
              <div className="gap-2 d-flex">
                <button
                  disabled={disableSaveBbutton}
                  id={`NGSRunCreationSave`}
                  onClick={handleSave}
                  className="btn btn-icon btn-sm fw-bold btn-table-save btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <DoneIcon />
                </button>
                <button
                  id={`NGSRunCreationCancel`}
                  onClick={() => {
                    loadGridData();
                    handleClose("dropdown2");
                    if (row?.id !== 0) {
                      const updatedRows = rows.map((r: any) => {
                        if (r.id === row?.id) {
                          return { ...r, rowStatus: false };
                        }
                        return r;
                      });
                      setRows(updatedRows);
                    } else {
                      const newArray = [...rows];
                      newArray.splice(index, 1);
                      setRows(newArray);
                      setIsAddButtonDisabled(true);
                    }
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-cancel btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <CrossIcon />
                </button>
              </div>
            ) : (
              <div className="rotatebtnn">
                <DropdownButton
                  className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                  key="end"
                  id={`NGSRunCreation3Dots_${row.id}`}
                  drop="end"
                  title={<i className="bi bi-three-dots-vertical p-0"></i>}
                >
                  {/* <PermissionComponent
                    moduleName="NGS LIS"
                    pageName="View Run"
                    permissionIdentifier="Complete"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id={`NGSRunCreationComplete`}
                        className="w-auto"
                        eventKey="1"
                        onClick={() => {
                          handleComplete([row.id]);
                        }}
                      >
                        <i className="fa-solid fa-circle-check text-primary mr-2"></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Complete"
                        )}
                      </Dropdown.Item>
                    )}
                  </PermissionComponent> */}
                  <PermissionComponent
                    moduleName="NGS LIS"
                    pageName="View Run"
                    permissionIdentifier="Delete"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id={`NGSRunCreationDelete`}
                        className="w-auto"
                        eventKey="2"
                        onClick={() => {
                          handleDeleteOrReject("delete", [row.id]);
                        }}
                      >
                        <i className={"fa fa-trash text-danger mr-2"}></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Delete"
                        )}
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="NGS LIS"
                    pageName="View Run"
                    permissionIdentifier="Reject"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id={`NGSRunCreationReject`}
                        className="w-auto"
                        eventKey="3"
                        onClick={() => {
                          handleDeleteOrReject("reject", [row.id]);
                        }}
                      >
                        <i className="fa-solid fa-x text-danger mr-2"></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Reject"
                        )}
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </DropdownButton>
              </div>
            )}
          </div>
        </TableCell>
        <TableCell
          id={`NGSRunCreationtestName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`NGSRunCreationDisplayName`}
                type="text"
                placeholder={t("Run Name")}
                name="runName"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.runName}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.runName
          )}
        </TableCell>
        <TableCell
          id={`NGSRunCreationorderCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="d-flex">
              <input
                id={`NGSRunCreationorderCode`}
                type="date"
                // placeholder={t("Display Name")}
                name="runDate"
                className="form-control mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={
                  row.id === 0
                    ? new Date().toISOString().split("T")[0]
                    : row?.runDate || ""
                }
                disabled
              />
            </div>
          ) : (
            moment(row?.runDate)?.format("MM/DD/YYYY")
          )}
        </TableCell>
        <TableCell
          id={`NGSRunCreationtmitCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="d-flex">
              <input
                id={`NGSRunCreationtmitCode`}
                type="text"
                placeholder={t("Created By")}
                name="createdName"
                className="form-control mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.createdName || ""}
                disabled
                // onChange={(e) =>
                //   handleChange(e.target.name, e.target.value, row?.testId)
                // }
              />
            </div>
          ) : (
            row?.createdName
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={9} className="padding-0">
          <Collapse in={isExpand} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography gutterBottom component="div">
                <div className="table-expend-sticky">
                  <div className="row">
                    <div className="col-lg-12 bg-white px-lg-14 px-md-10 px-4 pb-6">
                      <Expand
                        row={row}
                        loadGridData={loadGridData}
                        handleChange={handleChange}
                        queryDisplayTagNames={queryDisplayTagNames}
                      />
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
